export const isSandboxEnvironment = (): boolean =>
  process.env.DEPLOYMENT_ENV !== 'production';
